/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_File_Web_TitleInputs */

const en_pc_dl_file_web_title = /** @type {(inputs: Pc_Dl_File_Web_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web build`)
};

const zh_pc_dl_file_web_title = /** @type {(inputs: Pc_Dl_File_Web_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`网页版`)
};

/**
* | output |
* | --- |
* | "Web build" |
*
* @param {Pc_Dl_File_Web_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_file_web_title = /** @type {((inputs?: Pc_Dl_File_Web_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_File_Web_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_file_web_title(inputs)
	return zh_pc_dl_file_web_title(inputs)
});
export { pc_dl_file_web_title as "pc.dl.file.web.title" }